import { render, staticRenderFns } from "./Workprojectbudget.vue?vue&type=template&id=a5278c50&scoped=true&"
import script from "./Workprojectbudget.vue?vue&type=script&lang=js&"
export * from "./Workprojectbudget.vue?vue&type=script&lang=js&"
import style0 from "./Workprojectbudget.vue?vue&type=style&index=0&id=a5278c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5278c50",
  null
  
)

export default component.exports